module.exports = __webpack_public_path__ + "static/media/white.65bb6ee5.png";